import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { showSnackbar } from '../../../api/snackbarSlice';
import { useDispatch } from 'react-redux';
import { apiClient } from '../../../utils/axios';
import { AxiosError } from 'axios';

export const fetchProducts = async (query) => {
  const { data } = await apiClient.get(`/products`, { params: query.queryKey[1] });
  return data;
};

export const useGetProductsHandler = ({ searchQuery }) => {
  const dispatch = useDispatch();
  const [products, setProducts] = useState([]);
  const [totalDocuments, setTotalDocuments] = useState(0);

  const {
    data: fetchedData,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ['products', { ...searchQuery }], // A unique key for this query
    cacheTime: 0,
    queryFn: fetchProducts,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    refetchOnMount: 'always',
  });

  useEffect(() => {
    if (fetchedData) {
      setProducts(fetchedData.products);
      setTotalDocuments(fetchedData.totalDocuments);
    }
  }, [fetchedData]);

  useEffect(() => {
    if (isError) {
      if (error instanceof AxiosError) {
        if (error.status) {
          dispatch(showSnackbar({ message: error.response.data.message, severity: 'error' }));
        } else {
          dispatch(showSnackbar({ message: error.message, severity: 'error' }));
        }
      } else {
        dispatch(showSnackbar({ message: JSON.stringify(error), severity: 'error' }));
      }
    }
  }, [dispatch, error, isError]);

  return {
    products,
    totalDocuments,
    isLoading,
  };
};
